import React from "react";
import PropTypes from "prop-types";
import CheckListContainer from "../../../../features/document/edit/checklist/components/CheckListContainer";

const FolderCheckListContainer = ({ documentId, siteId }) => {
  return (
    <>
      <CheckListContainer documentId={documentId} siteId={siteId} isFromFolder={true} />
    </>
  );
};

FolderCheckListContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number
};

export default FolderCheckListContainer;
